import { PropsOf, chakra, forwardRef, useListStyles } from '@chakra-ui/react';
import { callAllHandlers } from '@chakra-ui/utils';
import React, { KeyboardEvent } from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';
import { useListContext } from '../List/List';

export interface ListItemProps extends OmitChakraProps<PropsOf<'li'>> {
  isDisabled?: boolean;
  isSelected?: boolean;
}

export const ListItem = forwardRef<ListItemProps, 'li'>(
  ({ isSelected, isDisabled, onClick, onKeyDown, ...props }, ref) => {
    const { isInteractive } = useListContext();
    const styles = useListStyles();
    const canInteract = isInteractive && !isDisabled;

    const handleKeyDown = callAllHandlers(
      onKeyDown,
      (e: KeyboardEvent<HTMLLIElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.currentTarget.click();
        }
      },
    );

    return (
      <chakra.li
        {...props}
        tabIndex={0}
        onClick={isDisabled ? undefined : onClick}
        role={isInteractive ? 'button' : undefined}
        aria-disabled={isDisabled}
        data-selected={isSelected ? true : undefined}
        onKeyDown={canInteract ? handleKeyDown : undefined}
        ref={ref}
        __css={styles.item}
      />
    );
  },
);
